module.exports = __webpack_public_path__ + "crm_static/img/explain.19108de5.png";